module.exports = __webpack_public_path__ + "img/ic_h5_vip3.5eebf7d1.png";